import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Database, FileText, Loader2, Sparkles, ChevronRight, LayoutDashboard, FileBarChart } from 'lucide-react';

export function ImportModelSelect({ fileName, models, modelsLoading, selectedModelId, setSelectedModelId, outputType, setOutputType, onBack, onProceed }) {
  return (
    <div className="flex flex-col items-center justify-center py-8 gap-5">
      <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
        <Database className="w-7 h-7 text-primary" />
      </div>
      <div className="text-center">
        <p className="text-lg font-medium">Choose a Semantic Model</p>
        <p className="text-sm text-muted-foreground mt-1">Select the data model to build against</p>
      </div>
      <div className="flex items-center gap-2 px-3 py-2 bg-muted/30 rounded-lg">
        <FileText className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm">{fileName}</span>
      </div>
      {modelsLoading ? (
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      ) : (
        <div className="w-80">
          <Select value={selectedModelId} onValueChange={setSelectedModelId}>
            <SelectTrigger className="w-full" data-testid="import-model-select">
              <SelectValue placeholder="Select a model..." />
            </SelectTrigger>
            <SelectContent>
              {models.map(m => <SelectItem key={m.model_id} value={m.model_id}>{m.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      <div className="w-80">
        <p className="text-xs text-muted-foreground mb-1.5 text-center">Create as</p>
        <div className="grid grid-cols-2 gap-2">
          <button
            type="button" data-testid="import-output-report"
            onClick={() => setOutputType('report')}
            className={`flex items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors ${outputType === 'report' ? 'border-primary bg-primary/10 text-primary' : 'border-border/50 hover:border-primary/40'}`}
          >
            <FileBarChart className="w-4 h-4" /> Report
          </button>
          <button
            type="button" data-testid="import-output-dashboard"
            onClick={() => setOutputType('dashboard')}
            className={`flex items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors ${outputType === 'dashboard' ? 'border-primary bg-primary/10 text-primary' : 'border-border/50 hover:border-primary/40'}`}
          >
            <LayoutDashboard className="w-4 h-4" /> Dashboard
          </button>
        </div>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onBack}>Back</Button>
        <Button onClick={onProceed} disabled={!selectedModelId} className="gap-2" data-testid="import-proceed-btn">
          <Sparkles className="w-4 h-4" /> Analyze <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
